import { Editor } from "tinymce";

export const handleEditorOnClick = (
  editor: Editor,
  onClickMergeTagSignButton?: () => void,
  onClickSelectInvoiceButton?: () => void
) => {
  /*
  Checklist plugin has a bug: if user clicks on a checkbox that exists
  inside an element that has text-align center or right, li class name
  "tox-checklist--checked" doesn't applied.
   */

  editor.on("click", (e) => {
    if (e.target?.localName === "li") {
      const element = e.target as Element;

      const before = getComputedStyle(e.target, ":before");

      if (before) {
        const pseudoLeft = Number(before.getPropertyValue("left").slice(0, -2));

        const pseudoWidth = Number(
          before.getPropertyValue("width").slice(0, -2)
        );

        const stepX = pseudoWidth * 0.5;
        const deltaXMax = pseudoWidth * 1.5;
        const deltaX = pseudoLeft - e.x;

        /*
        Here we need to make sure that user clicks exactly on "before"
        pseudo element of target li element.

        For example: <li>some text</li>
        If user click on "some" or "text" we should not trigger "checked"
        state.
        */

        if (
          element.parentElement?.classList.contains("tox-checklist") &&
          pseudoLeft &&
          pseudoWidth &&
          deltaX >= stepX &&
          deltaX <= deltaXMax &&
          isProblematicElement(element, 0)
        ) {
          if (!element.classList.contains("tox-checklist--checked")) {
            element.classList.add("tox-checklist--checked");
          } else if (element.classList.contains("tox-checklist--checked")) {
            element.classList.remove("tox-checklist--checked");
          }
          // Execute command that will trigger onChange event
          editor.execCommand("mceListUpdate", false, {});
        }
      }
    } else if (e.target?.localName === "button" || e.target.closest("button")) {
      const target = e.target as HTMLElement;

      const button =
        e.target?.localName === "button" ? target : target.closest("button");
      if (button?.classList.contains("sign-button")) {
        e.preventDefault();
        e.stopPropagation();
        onClickMergeTagSignButton?.();
      } else if (button?.classList.contains("select-invoice-button")) {
        e.preventDefault();
        e.stopPropagation();
        onClickSelectInvoiceButton?.();
      }
    }
  });
};

const CORRECT_ALIGNMENTS = ["left", "start", "justify"];

// Check if element or element.parentElement has "problematic" text alignment
const isProblematicElement = (
  element: Element | undefined | null,
  steps: number
): boolean => {
  if (!element) return false;

  const textAlign = getComputedStyle(element).textAlign;

  if (!CORRECT_ALIGNMENTS.some((alignment) => alignment === textAlign)) {
    return true;
  }

  return isProblematicElement(element.parentElement, steps + 1);
};
